// update state
const setDirectoryNameAction = (payload) => {
    return {
        type: "DIRECTORYNAME",
        payload
    }

}

export default setDirectoryNameAction;




// WEBPACK FOOTER //
// ./src/actions/setDirectoryNameAction.js